export const PRODUCT_RENDER_KEYS = [
  'rolloff-10yd',
  'rolloff-20yd',
  'rolloff-30yd',
  'rolloff-40yd',
  'frontload-2yd',
  'frontload-4yd',
  'frontload-6yd',
  'frontload-8yd',
  'compactor',
  'toter-96gal',
  'portable-toilet',
  'truck-rolloff',
  'truck-rolloff-empty',
  'truck-frontload',
  'truck-rearload',
  'truck-sideloader',
  'customer-site',
  'landfill',
  'transfer-station',
  'recycling-facility',
  'weighbridge',
  'zone-pin',
  'route',
  'price-card',
  'invoice',
  'payment-card',
  'scale-ticket',
  'calendar',
  'clock',
  'fuel',
  'hard-hat',
  'generic-bin',
  'generic-box',
  'generic-drum',
  'generic-tile',
] as const;

export type ProductRenderKey = (typeof PRODUCT_RENDER_KEYS)[number];
